import { IPublicAPI } from '../../interfaces/api/IPublicAPI';
import { ITestEnvironment } from '../../interfaces/test-environment/ITestEnvironment';
import { SessionSetupFunction } from '../../interfaces/core/ISessionManager';
import { TestSessionOptions, ITestSession } from '../../interfaces/core/ITestSession';
import { ISessionExecutionResult } from '../../interfaces/core/ISessionExecutor';
import { SessionResult } from '../../interfaces/results/SessionResult';
import { IEventEmitter, SessionEventType, SessionEvent } from '../../interfaces/events/IEventBus';
import { Container } from '../di/Container';

export class PublicAPI implements IPublicAPI {
  private container: Container;

  constructor() {
    this.container = Container.getInstance();
  }

  setup(config: Partial<ITestEnvironment>): void {
    this.container.setTestEnvironment(config);
  }

  getEnvironment(): ITestEnvironment {
    return this.container.testEnvironment;
  }

  async createSession(
    label: string,
    setupFn: SessionSetupFunction,
    options?: Partial<TestSessionOptions>
  ): Promise<string> {
    const useCase = this.container.createSessionUseCase();
    return useCase.execute(label, setupFn, options);
  }

  async runSession(label: string): Promise<ISessionExecutionResult> {
    const useCase = this.container.runSessionUseCase();
    return useCase.execute(label);
  }

  async runAllSessions(): Promise<SessionResult[]> {
    const useCase = this.container.runAllSessionsUseCase();
    return useCase.execute();
  }

  getSession(label: string): ITestSession | null {
    return this.container.sessionRepository.findByLabel(label);
  }

  getAllSessions(): ITestSession[] {
    return this.container.sessionRepository.findAll();
  }

  onSessionEvent(eventType: SessionEventType, callback: (event: SessionEvent) => void): void {
    this.container.eventBus.on(eventType, callback);
  }

  onAnySessionEvent(callback: (event: SessionEvent) => void): void {
    this.container.eventBus.onAny(callback);
  }

  offSessionEvent(eventType: SessionEventType, callback: (event: SessionEvent) => void): void {
    this.container.eventBus.off(eventType, callback);
  }

  getEventEmitter(): IEventEmitter {
    return this.container.eventBus;
  }
}
